module.exports = __webpack_public_path__ + "static/Data gathering-832c2a11a2d51374784289bcaa5e1aef.webp";